import { render } from "./ActiveOrders.vue?vue&type=template&id=34ab89c8"
import script from "./ActiveOrders.vue?vue&type=script&lang=js"
export * from "./ActiveOrders.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__